import * as types from './types';
import { execApi, execApiWithParam } from '../api/apiActions';

import MessagesApi from '../../apis/messages';


export const deleteMessage = (data, successCb, errorCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.DELETE_MESSAGE,
      api: MessagesApi.deleteMessage,
      param: data,
      successCallback: response => {
        if (successCb) successCb(response);
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      errorCallback: response => {
        if (errorCb) errorCb(response);
      },
      useErrorDialog: true,
    }));
  };
};

export const getAllMessageThreadHeaders = () => {
  return dispatch => {
    dispatch(execApi({
      type: types.FETCH_MESSAGE_THREAD_HEADERS,
      api: MessagesApi.getAllMessages,
      successCallback: response => {
        dispatch({
          type: types.FETCH_MESSAGE_THREAD_HEADERS,
          payload: response.headers,
        });
      },
      useErrorDialog: true,
    }));
  };
};

export const forwardMessage = (message, successCb, errorCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.FORWARD_MESSAGE,
      api: MessagesApi.forwardMessage,
      param: message,
      successCallback: response => {
        if (successCb) successCb(response);
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      errorCallback: response => {
        if (errorCb) errorCb(response);
      },
      useErrorDialog: true,
    }));
  };
};

export const getMessage = (threadId, successCb, errorCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.GET_MESSAGE,
      api: MessagesApi.getMessage,
      param: threadId,
      successCallback: response => {
        dispatch({
          type: types.GET_MESSAGE,
          payload: response.thread,
        });

        if (successCb) successCb(response);
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      errorCallback: response => {
        if (errorCb) errorCb(response);
      },
      useErrorDialog: true,
    }));
  };
};

export const getPossibleRecipients = () => {
  return dispatch => {
    dispatch(execApi({
      type: types.GET_POSSIBLE_RECIPIENTS,
      api: MessagesApi.getPossibleRecipients,
      successCallback: response => {
        dispatch({
          type: types.GET_POSSIBLE_RECIPIENTS,
          payload: response.recipients,
        });
      },
      useErrorDialog: true,
    }));
  };
};

export const replyMessage = (message, successCb, errorCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.REPLY_MESSAGE,
      api: MessagesApi.replyMessage,
      param: message,
      successCallback: response => {
        if (successCb) successCb(response);
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      errorCallback: response => {
        if (errorCb) errorCb(response);
      },
      useErrorDialog: true,
    }));
  };
};

export const sendMessage = (message, successCb, errorCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.SEND_MESSAGE,
      api: MessagesApi.sendMessage,
      param: message,
      successCallback: response => {
        if (successCb) successCb(response);
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      errorCallback: response => {
        if (errorCb) errorCb(response);
      },
      useErrorDialog: true,
    }));
  };
};



// WEBPACK FOOTER //
// ./src/actions/messages/messagesActions.js